export const notGameClick =
  'This category will update based on your progress in other categories. Look for the red notification dots to see what you need to complete'
export const notCompletedGameClick =
  'Please complete this category in the evaluation game app'
export const completedGameClick =
  'You have successfully completed this category. Look for the red notification dots to see what you need to complete'

export default {
  notGameClick,
  notCompletedGameClick,
  completedGameClick
}



// WEBPACK FOOTER //
// ./src/data/games/messages.ts